/**
 * External Dependencies
 */
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
window.Swiper = Swiper;
import 'alpinejs'
import 'hammerjs'

window.pageFunctions = function () {
    return {
        menuOpen: false,
        anchors: [],
        toTop() {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        },
        scrollToId(id) {
            console.log(id)
            const viewportOffset = document.getElementById(id).getBoundingClientRect();
            const header = document.getElementById('page-header').getBoundingClientRect();
            const additionalOffset = 0;
            window.scrollTo({
                top: viewportOffset.top + window.scrollY - header.height - additionalOffset,
                left: 0,
                behavior: 'smooth'
            });
        },
        createPageNav() {
            this.anchors = [...document.querySelectorAll('[data-anchor]')];
        }
    }
}
